/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-13 13:56:13
 * @LastEditTime: 2020-08-13 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/service/endpointService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";
/**
 * 用户列表
 */
export function getEndpointData(Info) {
  return request({
    url:
      "/api/v1/endpoints?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 新建Endpoint页面数据
 */
export function createEndpoint(data) {
  return request({
    url: "/api/v1/endpoints",
    method: "POST",
    data: data
  });
}
/*
 * 编辑Endpoint页面数据
 */
export function editEndpoint(data) {
  return request({
    url: "/api/v1/endpoints/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 获取Endpoint数据详情
 */
export function getEndpointInfo(id) {
  return request({
    url: "/api/v1/endpoints/" + id,
    method: "GET"
  });
}
/*
 * 删除Endpoint数据
 */
export function deleteEndpoint(id) {
  return request({
    url: "/api/v1/endpoints/" + id,
    method: "DELETE"
  });
}



// WEBPACK FOOTER //
// ./src/service/endpointService.js